import { ExpandMore, Refresh } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, FormLabel, Grid, Input, ListItem, ListItemButton, ListItemText, Slider, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import { useState } from "react"
import { FixedSizeList } from "react-window";
import { useDispatch, useSelector } from "react-redux";

// import { makeStyles } from "@mui/styles";

import { colors } from "../helpers/colors";
import { formatUwi } from "../helpers/formatUwi";
import { parseCsv } from "../helpers/parseCsv";

import { addWells, selectWells, updateWellsStatus } from "../reducers/wellSlice";
import { selectLists } from '../reducers/listSlice';
import { getTypeCurveForecast, getTypeCurves, selectTypeCurves } from "../reducers/typeCurveSlice";
import { getGroupWellForecast, getGroupWells, selectGroupWells } from "../reducers/groupWellSlice";
import { selectUser } from "../reducers/userSlice";
import uuid from "react-uuid";
import { useSocket } from "../context/useSocket";

const MONTH_LENGTH = 30.436875;

export const NewWell = ({ newWellClose, listId }) => {
  

  const { socket } = useSocket();

  const user = useSelector(selectUser);
  const lists = useSelector(selectLists);
  const wells = useSelector(selectWells);
  const typeCurves = useSelector(selectTypeCurves);
  const groupWells = useSelector(selectGroupWells);

  const [uwis, setUwis] = useState("");
  const [dataType, setDataType] = useState("csv");
  const [dataFrequency, setDataFrequency] = useState("monthly");
  const [dataUnits, setDataUnits] = useState("metric");

  const [productionData, setProductionData] = useState({});
  const [newDrillSource, setNewDrillSource] = useState('well');
  const [newDrillOffset, setNewDrillOffset] = useState(1);
  const [newDrillSourceItemIndex, setNewDrillSourceItemIndex] = useState(undefined);
  const [newDrillSourceName, setNewDrillSourceName] = useState("");
  const [newDrillSourcePads, setNewDrillSourcePads] = useState(1);
  const [newDrillSourceWellsPerPad, setNewDrillSourceWellsPerPad] = useState(1);
  const [newDrillCopyOffset, setNewDrillCopyOffset] = useState('on');
  const [newDrillCopyOffsetValue, setNewDrillCopyOffsetValue] = useState(1);
  const [newDrillStartDate, setNewDrillStartDate] = useState(new Date().toISOString().split('T')[0]);

  const [isLoadingTypeCurves, setIsLoadingTypeCurves] = useState(false);
  const [isLoadingGroupWells, setIsLoadingGroupWells] = useState(false);
  const [localWells, setLocalWells] = useState(false);

  const dispatch = useDispatch();

  return (
    <Dialog 
      open={true} 
      onClose={newWellClose}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle id="form-dialog-title">Add Wells</DialogTitle>
      <DialogContent>
        
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMore />}>Add wells by UWIs</AccordionSummary>
          <AccordionDetails>
            <FormControl style={{width: '100%'}}>
              <TextField
                autoFocus
                margin="normal"
                id="uwis"
                label="Well UWIs"
                type="text"
                fullWidth
                multiline
                minRows={10}
                maxRows={10}
                value={uwis}
                variant="outlined"
                placeholder='103063504614W500, 103/06-35-046-14W5/00'
                onChange={e => setUwis(e.target.value)}
              />
              <FormHelperText id="my-helper-text">Enter UWIs on new lines or separated by commas.</FormHelperText>
            </FormControl>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>Import production data</AccordionSummary>
          <AccordionDetails>

            <FormControl component="fieldset" style={{width: '100%'}}>
              <FormLabel component="legend">File Type</FormLabel>
              <ToggleButtonGroup
                value={dataType}
                exclusive
                onChange={handleDataTypeChange}
                size="small"
                style={{height: 30, width: '100%', display: 'flex', justifyContent: 'center'}}
              >
                <ToggleButton value="csv" size="small" style={{width: '50%'}} color="primary">
                  <Typography style={{fontSize: 12}}>
                    CSV
                  </Typography>
                </ToggleButton>
                <ToggleButton value="json" size="small" style={{width: '50%'}} disabled color="primary">
                  <Typography style={{fontSize: 12}}>
                    JSON
                  </Typography>
                </ToggleButton>
              </ToggleButtonGroup>
            </FormControl>

            <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
              <FormLabel component="legend">Data Frequency</FormLabel>
              <ToggleButtonGroup
                value={dataFrequency}
                exclusive
                onChange={handleDataFrequencyChange}
                size="small"
                style={{height: 30, width: '100%', display: 'flex', justifyContent: 'center'}}
              >
                <ToggleButton value="monthly" size="small" style={{width: '33.33%'}} color="primary">
                  <Typography style={{fontSize: 12}}>
                    Monthly
                  </Typography>
                </ToggleButton>
                <ToggleButton value="daily" size="small" style={{width: '33.33%'}} color="primary" disabled>
                  <Typography style={{fontSize: 12}}>
                    Daily
                  </Typography>
                </ToggleButton>
                <ToggleButton value="hourly" size="small" style={{width: '33.33%'}} color="primary" disabled>
                  <Typography style={{fontSize: 12}}>
                    Hourly
                  </Typography>
                </ToggleButton>
              </ToggleButtonGroup>
            </FormControl>

            <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
              <FormLabel component="legend">Units</FormLabel>
              <ToggleButtonGroup
                value={dataUnits}
                exclusive
                onChange={handleDataUnitsChange}
                size="small"
                style={{height: 30, width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 20}}
              >
                <ToggleButton value="metric" size="small" style={{width: '50%'}} color="primary">
                  <Typography style={{fontSize: 12}}>
                    Metric
                  </Typography>
                </ToggleButton>
                <ToggleButton value="field" size="small" style={{width: '50%'}} color="primary">
                  <Typography style={{fontSize: 12}}>
                    Field
                  </Typography>
                </ToggleButton>
              </ToggleButtonGroup>
            </FormControl>

            <FormControl style={{width: '100%', marginTop: 20}}>
              <FormLabel component="legend">Upload File</FormLabel>
              <Input id="file-input" accepts={`${dataType}.csv`} type="file" aria-describedby="my-helper-text" onChange={e => handleUploadData(e)} />
              <FormHelperText id="my-helper-text">Accepted formats: {dataType.toUpperCase()}.</FormHelperText>
            </FormControl>

          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>New drill</AccordionSummary>
          <AccordionDetails>
            <FormControl component="fieldset" style={{width: '100%'}}>
              <FormLabel component="legend">Source</FormLabel>
              <ToggleButtonGroup
                value={newDrillSource}
                exclusive
                onChange={handleNewDrillSourceChange}
                size="small"
                style={{height: 30, width: '100%', display: 'flex', justifyContent: 'center'}}
              >
                <ToggleButton value="well" size="small" style={{width: '33.3%'}} color="primary">
                  <Typography style={{fontSize: 12}}>
                    Well
                  </Typography>
                </ToggleButton>
                <ToggleButton value="typeCurve" size="small" style={{width: '33.3%'}} color="primary">
                  <Typography style={{fontSize: 12}}>
                    Type Curve
                  </Typography>
                </ToggleButton>
                <ToggleButton value="groupWell" size="small" style={{width: '33.3%'}} color="primary">
                  <Typography style={{fontSize: 12}}>
                    Group Well
                  </Typography>
                </ToggleButton>
              </ToggleButtonGroup>
            </FormControl>

            <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
              <FormLabel component="legend">{getNewDrillTitle(newDrillSource)}</FormLabel>
              {/* <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <Search />
                </div>
                <InputBase
                  placeholder="Search wells by UWI"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  value={searchUwi}
                  onChange={e => setSearchUwi(e.target.value)}
                />
              </div> */}
              {getNewDrillSourceList(newDrillSource)}
            </FormControl>

            {
            !isNaN(newDrillSourceItemIndex) ?
            <>
              <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
                <FormLabel component="legend">New Drill Name</FormLabel>
                <Input disabled value={newDrillSourceName} onChange={e => setNewDrillSourceName(e.target.value)} placeholder="New drill" style={{width: '100%'}}></Input>
              </FormControl>

              <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
                <FormLabel component="legend">Number of Pads</FormLabel>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs style={{margin: '0 10px'}}>
                    <Slider
                      value={newDrillSourcePads}
                      onChange={(e, newValue) => handleNewDrillSourcePadsSliderChange(e, newValue)}
                      min={1}
                      max={10}
                      step={1}
                      valueLabelDisplay="auto"
                    />
                  </Grid>
                  <Grid item>
                    <Input
                      value={newDrillSourcePads}
                      margin="dense"
                      style={{width: 50}}
                      onChange={(e) => handleNewDrillSourcePadsInputChange(e)}
                      inputProps={{
                        min: 1,
                        max: 10,
                        step: 1,
                        type: 'number',
                      }}
                    />
                  </Grid>
                </Grid>
              </FormControl>

              <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
                <FormLabel component="legend">Wells per Pad</FormLabel>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs style={{margin: '0 10px'}}>
                    <Slider
                      value={newDrillSourceWellsPerPad}
                      onChange={(e, newValue) => handleNewDrillSourceWellsPerPadSliderChange(e, newValue)}
                      min={1}
                      max={10}
                      step={1}
                      valueLabelDisplay="auto"
                    />
                  </Grid>
                  <Grid item>
                    <Input
                      value={newDrillSourceWellsPerPad}
                      margin="dense"
                      style={{width: 50}}
                      onChange={(e) => handleNewDrillSourceWellsPerPadInputChange(e)}
                      inputProps={{
                        min: 1,
                        max: 10,
                        step: 1,
                        type: 'number',
                      }}
                    />
                  </Grid>
                </Grid>
              </FormControl>


              <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
                <FormLabel component="legend">New Drill Start</FormLabel>
                <Input type="date" value={newDrillStartDate} onChange={e => {
                  const date = e.target.value;
                  setNewDrillStartDate(date);
                }} />
              </FormControl>


              <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
                <FormLabel component="legend">Time Offset Pads</FormLabel>
                <ToggleButtonGroup
                  value={newDrillCopyOffset}
                  exclusive
                  onChange={handleNewDrillCopyOffsetChange}
                  size="small"
                  style={{height: 30, width: '100%', display: 'flex', justifyContent: 'center'}}
                >
                  <ToggleButton value="on" size="small" style={{width: '50%'}} color="primary">
                    <Typography style={{fontSize: 12}}>
                      On
                    </Typography>
                  </ToggleButton>
                  <ToggleButton value="off" size="small" style={{width: '50%'}} color="primary">
                    <Typography style={{fontSize: 12}}>
                      Off
                    </Typography>
                  </ToggleButton>
                </ToggleButtonGroup>
              </FormControl>

              {newDrillCopyOffset === 'on' &&
              <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
                <FormLabel component="legend">Time Offset Months</FormLabel>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs style={{margin: '0 10px'}}>
                    <Slider
                      value={newDrillCopyOffsetValue}
                      onChange={(e, newValue) => handleNewDrillOffsetValueSliderChange(e, newValue)}
                      min={1}
                      max={60}
                      step={1}
                      valueLabelDisplay="auto"
                    />
                  </Grid>
                  <Grid item>
                    <Input
                      value={newDrillCopyOffsetValue}
                      margin="dense"
                      style={{width: 50}}
                      onChange={(e) => handleNewDrillOffsetValueInputChange(e)}
                      inputProps={{
                        min: 1,
                        max: 60,
                        step: 1,
                        type: 'number',
                      }}
                    />
                  </Grid>
                </Grid>
              </FormControl>}

              <FormControl component="fieldset" style={{width: '100%', marginTop: 20}}>
                <FormLabel component="legend">Production Offset Multiplier</FormLabel>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs style={{margin: '0 10px'}}>
                    <Slider
                      value={newDrillOffset}
                      onChange={(e, newValue) => handleNewDrillOffsetSliderChange(e, newValue)}
                      min={0.1}
                      max={2}
                      step={0.01}
                      valueLabelDisplay="auto"
                    />
                  </Grid>
                  <Grid item>
                    <Input
                      value={newDrillOffset}
                      margin="dense"
                      style={{width: 50}}
                      onChange={(e) => handleNewDrillOffsetInputChange(e)}
                      inputProps={{
                        min: 0.1,
                        max: 2,
                        step: 0.01,
                        type: 'number',
                      }}
                    />
                  </Grid>
                </Grid>
              </FormControl>
            </>
            :
            <div style={{textAlign: 'center', marginTop: 40, marginBottom: 40}}>
              <Typography>Please select a source well</Typography>
            </div>
            }
          </AccordionDetails>
        </Accordion>
      </DialogContent>
      <DialogActions>
        <Button onClick={newWellClose} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={() => addWellClick(uwis, productionData, listId, false)} 
          color="primary" 
          disabled={uwis?.length === 0 && Object.keys(productionData)?.length === 0 && isNaN(newDrillSourceItemIndex)}
        >
          Add
        </Button>
        <Button 
          onClick={() => addWellClick(uwis, productionData, listId, true)} 
          color="primary" 
          variant="contained" 
          disabled={uwis?.length === 0 && Object.keys(productionData)?.length === 0 && isNaN(newDrillSourceItemIndex)}
        >
          Add and Process
        </Button>
      </DialogActions>
    </Dialog>
  );

  

  // FUNCTIONS
  async function handleUploadData(e) { // handle production data uploading
    let files = e.target.files;

    if (!files.length > 0) return false;
    
    let reader = new FileReader();
    
    reader.readAsText(files[0]);
    
    reader.onload = async (event) => {
      let result = event.target.result;

      if (result.length > 0) {
        const production = await parseCsv(result, dataUnits);
        production && setProductionData(production);
        setLocalWells(true);
      };
    };
  };

  function formatDate(date) {
    try {
      let year = 0;
      let month = 0;
      let formattedDate = '';

      if (!date) return date;

      if (date?.includes('/')) { // if date is in MM/DD/YYYY format
        year = date.split('/')[2];
        month = date.split('/')[0];
        formattedDate = `${year}-02-${month}`;
      } else {
        formattedDate = date;
      };

      return formattedDate;
      
    } catch (error) {
      console.log(error);
      return date;
    };
  };

  function handleDataTypeChange(e, newValue) {
    newValue && setDataType(newValue);
  };

  function handleDataFrequencyChange(e, newValue) {
    newValue && setDataFrequency(newValue);
  };

  function handleDataUnitsChange(e, newValue) {
    newValue && setDataUnits(newValue);
  };

  function handleNewDrillSourceChange(e, newValue) {
    newValue && setNewDrillSource(newValue);
  };

  function handleNewDrillOffsetSliderChange(e, newValue) {
    !isNaN(newValue) && setNewDrillOffset(newValue);
  };

  function handleNewDrillOffsetValueSliderChange(e, newValue) {
    !isNaN(newValue) && setNewDrillCopyOffsetValue(newValue);
  };

  function handleNewDrillOffsetInputChange(e) {
    e.target.value && setNewDrillOffset(Number(e.target.value));
  };

  function handleNewDrillOffsetValueInputChange(e) {
    e.target.value && setNewDrillCopyOffsetValue(Math.floor(e.target.value));
  };

  function handleNewDrillSourcePadsSliderChange(e, newValue) {
    !isNaN(newValue) && setNewDrillSourcePads(newValue);
  };
  
  function handleNewDrillSourcePadsInputChange(e) {
    e.target.value && setNewDrillSourcePads(Math.floor(e.target.value));
  };
  
  function handleNewDrillSourceWellsPerPadSliderChange(e, newValue) {
    !isNaN(newValue) && setNewDrillSourceWellsPerPad(newValue);
  };
  function handleNewDrillSourceWellsPerPadInputChange(e) {
    e.target.value && setNewDrillSourceWellsPerPad(Math.floor(e.target.value));
  };

  function handleNewDrillCopyOffsetChange(e, newValue) {
    newValue && setNewDrillCopyOffset(newValue);
  };


  function getNewDrillTitle(source) {
    switch(source) {
      case 'well':
        return 'Wells';
      case 'typeCurve':
        return 'Type Curves';
      case 'groupWell':
        return 'Group Wells';
      default:
        return '';
    };
  };

  function getNewDrillSourceList(source) {
    switch(source) {
      case 'well':
        let sourceWells = lists?.byId[listId]?.wellUwis?.filter(uwi => wells?.byUwi?.[uwi]?.status === 'processed')?.map(uwi => wells?.byUwi[uwi]?.formattedUwi || uwi);
        return (
          <FixedSizeList
            height={300}
            width={'100%'}
            itemSize={46}
            itemCount={sourceWells?.length || 0}
            // overscanCount={5}
            style={{border: '1px solid lightgrey', borderRadius: '5px'}}
          >
            {renderNewDrillSourceRow}
          </FixedSizeList>
        );
      case 'typeCurve':
        let sourceTypeCurves = typeCurves?.allIds?.map(id => typeCurves?.byId[id]?.name || '');
        return (
          <>
            <Button onClick={e => handleRefreshTypeCurves(e)} startIcon={<Refresh />} size="small" style={{width: 120, margin: '20px 0'}}>Refresh</Button>
            {isLoadingTypeCurves ? 
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: 400}}>
              <Typography style={{marginBottom: 20}}>Loading type curves...</Typography>
              <CircularProgress></CircularProgress>
            </div> :
            <FixedSizeList
              height={300}
              width={'100%'}
              itemSize={46}
              itemCount={sourceTypeCurves?.length || 0}
              overscanCount={5}
              style={{border: '1px solid lightgrey', borderRadius: '5px'}}
              >
              {renderNewDrillSourceRow}
            </FixedSizeList>}
          </>
        );
      case 'groupWell':
        let sourceGroupWells = groupWells?.allIds?.map(id => groupWells?.byId[id]?.name || '');
        return (
          <>
            <Button onClick={e => handleRefreshGroupWells(e)} startIcon={<Refresh />} size="small" style={{width: 120, margin: '20px 0'}}>Refresh</Button>
            {isLoadingGroupWells ? 
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: 400}}>
              <Typography style={{marginBottom: 20}}>Loading group wells...</Typography>
              <CircularProgress></CircularProgress>
            </div> :
            <FixedSizeList
              height={300}
              width={'100%'}
              itemSize={46}
              itemCount={sourceGroupWells?.length || 0}
              overscanCount={5}
              style={{border: '1px solid lightgrey', borderRadius: '6px'}}
              >
              {renderNewDrillSourceRow}
            </FixedSizeList>}
          </>
        );
      default:
        return (
          <></>
        );
    };
  };

  function renderNewDrillSourceRow(props) {
    const { index, style } = props;

    return (
      <ListItem style={style} key={index} component="div" disablePadding selected={index === newDrillSourceItemIndex}>
        <ListItemButton onClick={() => handleNewDrillSourceItemSelect(index)}>
          <ListItemText primary={getNewDrillSourceItem(newDrillSource, index)} />
        </ListItemButton>
      </ListItem>
    );
  };

  async function handleNewDrillSourceItemSelect(index) {
    if (index !== newDrillSourceItemIndex) {
      setNewDrillSourceItemIndex(index);
      
      if (newDrillSource === 'typeCurve') {
        const typeCurve = typeCurves?.byId?.[typeCurves?.allIds?.[index]];
        
        if (!typeCurve?.forecast && typeCurve?.location) {
          await importTypeCurve(typeCurve?.location, user?.value?.email);
        };
      } else if (newDrillSource === 'groupWell') {
        const groupWell = groupWells?.byId?.[groupWells?.allIds?.[index]];
        
        if (!groupWell?.forecast && groupWell?.location) {
          await importGroupWell(groupWell?.location, user?.value?.email);
        };
      };
      setNewDrillSourceName(() => getNewDrillSourceItem(newDrillSource, index));
    } else {
      setNewDrillSourceItemIndex(undefined);
      setNewDrillSourceName("");
    };
  };

  async function importTypeCurve(location, userEmail) {
    try {
      console.log(`Fetching type curve from S3 ${location}...`);

      const res = await fetch(location, {cache: "no-store"});
      const tc = await res.json();

      if (!tc) return;

      let forecast;

      if (tc?.createdBy !== userEmail && !tc?.public) {
        console.log('Changing type curve owner...');
        dispatch(getTypeCurveForecast({...tc, id: uuid(), createdBy: userEmail, lastModified: new Date()}))
        .then(res => {
          forecast = res.payload;
        });
      } else {
        dispatch(getTypeCurveForecast({...tc, location}))
        .then(res => {
          forecast = res.payload;
        });
      };

      return forecast;
    } catch (error) {
      console.log(error);
      return;
    };
  };

  async function importGroupWell(location, userEmail) {
    try {
      console.log(`Fetching group well from S3 ${location}...`);

      const res = await fetch(location, {cache: "no-store"});
      const gw = await res.json();

      if (!gw) return;

      let forecast;

      if (gw?.createdBy !== userEmail && !gw?.public) {
        console.log('Changing group well owner...');
        dispatch(getTypeCurveForecast({...gw, id: uuid(), createdBy: userEmail, lastModified: new Date()}))
        .then(res => {
          forecast = res.payload;
        });
      } else {
        dispatch(getGroupWellForecast({...gw, location}))
        .then(res => {
          forecast = res.payload;
        });
      };

      return forecast;
    } catch (error) {
      console.log(error);
      return;
    };
  };

  function getNewDrillSourceItem(source, index) {
    switch(source) {
      case 'well':
        let sourceWells = lists.byId[listId]?.wellUwis?.filter(uwi => wells?.byUwi?.[uwi]?.status === 'processed');
        return wells?.byUwi?.[sourceWells?.[index]]?.formattedUwi || wells?.byUwi?.[sourceWells?.[index]]?.uwi || '';
      case 'typeCurve':
        let sourceTypeCurves = typeCurves?.allIds;
        return typeCurves?.byId?.[sourceTypeCurves?.[index]]?.name || '';
      case 'groupWell':
        return groupWells?.byId?.[groupWells?.allIds?.[index]]?.name || '';
      default:
        return '';
    };
  };

  async function addWellClick(uwis, production, listId, process) { // add (and process) well(s) by uwi  
    try {
      if (uwis?.length > 0) { // if processing by UWI
        let uwiString = uwis.trim().replaceAll(/[,]+/ig,'\n');
        let uwiArray = uwiString.replaceAll(/[^a-zA-Z0-9\n]+/ig,'').toUpperCase().split('\n');
        uwiArray = [...new Set(uwiArray)]; // ensure no duplicates
        if (uwiArray?.length > 0) {
          let wells = {};
          for (let uwi of uwiArray) {
            if (uwi?.length > 0) {
              const color = colors[Math.floor(Math.random() * colors.length - 2)] || colors[0];
              wells[uwi] = {
                uwi: uwi,
                formattedUwi: formatUwi(uwi),
                color: color,
                lastModified: new Date().toLocaleString(),
                status: 'idle'
              };
            };
          };
          newWellClose();
          dispatch(addWells({uwis: uwiArray, wells: wells, listId: listId}));
          if (process) {
            dispatch(updateWellsStatus({uwis: uwiArray, status: 'processing'})); // Set wells' status to processing

            if (socket && socket.readyState === 1) {
              socket.send(JSON.stringify({
                messageType: 'process', 
                payload: uwiArray || [], 
                userEmail: user?.value?.email, 
                params: {},
                localParams: [],
                reFit: false,
                assistedForecast: false, 
                tcParams: false
              }));
            };
          };
          setUwis("");
          setProductionData({});
        };
      } else if (production && Object.keys(production).length > 0) { // if processing by CSV data
        let wells = {};
        const uwiArray = Object.keys(production);
        if (!uwiArray || uwiArray.length === 0) return;
        uwiArray.forEach(uwi => {
          const color = colors[Math.floor(Math.random() * colors.length - 2)] || colors[0];
          wells[uwi] = {
            uwi,
            formattedUwi: (localWells ? uwi : formatUwi(uwi)),
            color,
            lastModified: new Date().toLocaleString(),
            status: (process ? 'processing' : 'idle'),
            production: production[uwi],
            local: true
          };
        });
        dispatch(addWells({uwis: uwiArray, wells: wells, listId: listId}));
        newWellClose();
        if (process) {
          const wellsArray = uwiArray.map(uwi => wells[uwi]);
          dispatch(updateWellsStatus({uwis: uwiArray, status: 'processing'})); // Set wells' status to processing
          if (socket && socket.readyState === 1) {
            socket.send(JSON.stringify({
              messageType: 'localWell', 
              payload: wellsArray,
              userEmail: user?.value?.email,
              assistedForecast: false,
              tcParams: false
            }));
          };
        };
        setUwis("");
        setProductionData({});
      } else if (newDrillSourceItemIndex >= 0) { // if processing new drills
        let newDrillWells = {};
        for (let i = 1; i <= newDrillSourcePads; i++) {
          
          for (let j = 1; j <= newDrillSourceWellsPerPad; j++) {
            const color = colors[Math.floor(Math.random() * colors.length - 2)] || colors[0];
            const sourceUwi = newDrillSourceName?.replaceAll(/[^a-zA-Z0-9\s]+/ig, '');
            const copyUwi = `${sourceUwi}-${i}${j}`;
            const copyFormattedUwi = `${newDrillSourceName}-${i}${j}`;

            const { production, eur } = await getNewDrillSourceProduction(newDrillSource, newDrillSourceItemIndex, (i === 1 ? 'off' : newDrillCopyOffset), ((i-1) * newDrillCopyOffsetValue), newDrillSourceName, true);

            // calculate EUR
            if (!production || production?.fluids?.length === 0) return;
  
            newDrillWells[copyUwi] = {
              uwi: copyUwi,
              formattedUwi: copyFormattedUwi,
              color,
              lastModified: new Date().toLocaleString(),
              status: 'processed',
              details: wells.byUwi[sourceUwi]?.details || {},
              completions: wells.byUwi[sourceUwi]?.completions || {},
              production,
              eur,
              local: true,
              copy: true
            };
          };
        };

        dispatch(addWells({uwis: Object.keys(newDrillWells), wells: newDrillWells, listId: listId}));
        setNewDrillSourceItemIndex(undefined);
        setNewDrillSourceName('');
        newWellClose();
      };
    } catch (error) {
      console.log(error);
      return;
    };

    async function getNewDrillSourceProduction(source, index, dateOffsetFlag, offsetValue, name) {
      try {
        const plainName = name?.replaceAll(/[^a-zA-Z0-9\s]+/ig, '');

        switch(source) {
          case 'well':
            try {
              console.log('Adding new drill from well');
              let wellProduction = {byFluid: {}, fluids: []};
              let eur = {...wells?.byUwi?.[plainName]?.eur};
              if (!eur || Object.keys(eur).length === 0) eur = {...wells?.byUwi?.[name]?.eur}; // for local wells

              let sourceProduction = wells?.byUwi?.[plainName]?.forecast;
              if (!sourceProduction) sourceProduction = wells?.byUwi?.[name]?.forecast; // for local wells

              sourceProduction && Object.keys(sourceProduction?.byFluid).forEach(fluid => {
                
                let parsedNewDrillStartDate = formatDate(newDrillStartDate); // convert the date format
                parsedNewDrillStartDate = new Date(`${parsedNewDrillStartDate?.split('-')?.[1]}/2/${parsedNewDrillStartDate?.split('-')?.[0]}`); // convert the date format
                
                let startDate = new Date(parsedNewDrillStartDate);
                if (dateOffsetFlag === 'on') {
                  startDate = new Date(startDate.setMonth(startDate.getMonth() + offsetValue)); // this is the first date of the new drill
                };
                if (startDate.getDate() === 27 || startDate.getDate() === 28 || startDate.getDate() === 29 || startDate.getDate() === 30 || startDate.getDate() === 31) {
                  startDate.setDate(2);
                  startDate.setMonth(startDate.getMonth() + 1);
                };

                const wellstartDate = new Date(sourceProduction.byFluid[fluid]?.[0]?.date); // this is the first date of the source well

                const timeDelta = startDate?.getTime() - wellstartDate?.getTime(); // calculate time difference between provided date and well's start date
                const fullMonthsDelta = Math.ceil(timeDelta / (1000 * 60 * 60 * 24 * MONTH_LENGTH)); // convert time delta to full months

                wellProduction.byFluid[fluid] = sourceProduction.byFluid[fluid].map((p,i) => {
                  let date;
                  if (i === 0) {
                    date = startDate;
                  } else {
                    date = new Date(new Date(startDate).setMonth(startDate.getMonth() + p.monthsOnline - 1))
                  };
                  return {
                    ...p, 
                    volume: (p.volume.p50 * newDrillOffset), 
                    cumVolume: (p.cumVolume.p50 * newDrillOffset), 
                    date: date?.toISOString()?.split('T')?.[0]
                  };
                });

                let newFluidEur = {
                  p10: {},
                  p50: {},
                  p90: {}
                };
                ['p10','p50','p90'].forEach(prob => {
                  let newProb = {...eur.byFluid[fluid][prob]};
                  const date = new Date(new Date(newProb.date)?.setMonth(new Date(newProb.date)?.getMonth() + fullMonthsDelta)); // shift the Eur date by the delta
                  newProb.date = date?.toISOString()?.split('T')?.[0];
                  newFluidEur[prob] = newProb;
                });
                eur.byFluid = {...eur.byFluid, [fluid]: newFluidEur};

                if (wellProduction.fluids.indexOf(fluid) === -1) wellProduction.fluids.push(fluid);
              });

              return {production: wellProduction, eur};
            } catch (error) {
              console.log(error);
              return {};
            };
            
          case 'typeCurve':
            try {
              console.log('Adding new drill from type curve');
              let typeCurve = typeCurves.byId[typeCurves.allIds[index]];

              let wellProduction = {byFluid: {}, fluids: []};
              let eur = {...typeCurve?.eur};
            
              const sourceProduction = typeCurve?.forecast;

              sourceProduction && Object.keys(sourceProduction?.byFluid)?.length > 0 && Object.keys(sourceProduction?.byFluid).forEach(fluid => {

                let parsedNewDrillStartDate = formatDate(newDrillStartDate); // convert the date format
                parsedNewDrillStartDate = new Date(`${parsedNewDrillStartDate?.split('-')?.[1]}/2/${parsedNewDrillStartDate?.split('-')?.[0]}`); // convert the date format

                let startDate = new Date(parsedNewDrillStartDate);

                if (dateOffsetFlag === 'on') {
                  startDate = new Date(startDate.setMonth(startDate.getMonth() + offsetValue)); // this is the first date of the new drill
                };
                if (startDate.getDate() === 27 || startDate.getDate() === 28 || startDate.getDate() === 29 || startDate.getDate() === 30 || startDate.getDate() === 31) {
                  startDate.setDate(2);
                  startDate.setMonth(startDate.getMonth() + 1);
                };

                const wellstartDate = new Date(sourceProduction.byFluid[fluid]?.[0]?.date || parsedNewDrillStartDate); // this is the first date of the source well

                const timeDelta = startDate?.getTime() - wellstartDate?.getTime(); // calculate time difference between provided date and well's start date
                const fullMonthsDelta = Math.ceil(timeDelta / (1000 * 60 * 60 * 24 * MONTH_LENGTH)); // convert time delta to full months

                wellProduction.byFluid[fluid] = sourceProduction.byFluid[fluid].map((p,i) => {
                  let date;
                  if (i === 0) {
                    date = startDate;
                  } else {
                    date = new Date(new Date(startDate).setMonth(startDate.getMonth() + p.monthsOnline - 1))
                  };
                  return {
                    ...p, 
                    volume: (p.volume.p50 * newDrillOffset), 
                    cumVolume: (p.cumVolume.p50 * newDrillOffset), 
                    date: date?.toISOString()?.split('T')?.[0]
                  };
                });

                let newFluidEur = {
                  p10: {},
                  p50: {},
                  p90: {}
                };
                ['p10','p50','p90'].forEach(prob => {
                  let newProb = {...eur.byFluid[fluid][prob]};
                  const date = new Date(new Date(newProb.date)?.setMonth(new Date(newProb.date)?.getMonth() + fullMonthsDelta)); // shift the Eur date by the delta
                  newProb.date = date?.toISOString()?.split('T')?.[0];
                  newFluidEur[prob] = newProb;
                });
                eur.byFluid = {...eur.byFluid, [fluid]: newFluidEur};

                if (wellProduction.fluids.indexOf(fluid) === -1) wellProduction.fluids.push(fluid);
              });

              return {production: wellProduction, eur};
            } catch (error) {
              console.log(error);
              return {};
            };
          case 'groupWell':
            try {
              console.log('Adding new drill from group well');
              const groupWell = groupWells.byId[groupWells.allIds[index]];
              let wellProduction = {byFluid: {}, fluids: []};
              let eur = {...groupWell?.eur};

              const sourceProduction = groupWell?.forecast;

              sourceProduction && Object.keys(sourceProduction.byFluid).forEach(fluid => {
                
                let parsedNewDrillStartDate = formatDate(newDrillStartDate); // convert the date format
                parsedNewDrillStartDate = new Date(`${parsedNewDrillStartDate?.split('-')?.[1]}/2/${parsedNewDrillStartDate?.split('-')?.[0]}`); // convert the date format

                let startDate = new Date(parsedNewDrillStartDate);

                if (dateOffsetFlag === 'on') {
                  startDate = new Date(startDate.setMonth(startDate.getMonth() + offsetValue)); // this is the first date of the new drill
                };
                if (startDate.getDate() === 27 || startDate.getDate() === 28 || startDate.getDate() === 29 || startDate.getDate() === 30 || startDate.getDate() === 31) {
                  startDate.setDate(2);
                  startDate.setMonth(startDate.getMonth() + 1);
                };

                const wellstartDate = new Date(sourceProduction.byFluid[fluid]?.[0]?.date); // this is the first date of the source well

                const timeDelta = startDate?.getTime() - wellstartDate?.getTime(); // calculate time difference between provided date and well's start date
                const fullMonthsDelta = Math.ceil(timeDelta / (1000 * 60 * 60 * 24 * MONTH_LENGTH)); // convert time delta to full months

                wellProduction.byFluid[fluid] = sourceProduction.byFluid[fluid].map((p,i) => {
                  let date;
                  if (i === 0) {
                    date = startDate;
                  } else {
                    date = new Date(new Date(startDate).setMonth(startDate.getMonth() + p.monthsOnline - 1))
                  };
                  return {
                    ...p, 
                    volume: (p.volume.p50 * newDrillOffset), 
                    cumVolume: (p.cumVolume.p50 * newDrillOffset), 
                    date: date?.toISOString()?.split('T')?.[0]
                  };
                });

                let newFluidEur = {
                  p10: {},
                  p50: {},
                  p90: {}
                };
                ['p10','p50','p90'].forEach(prob => {
                  let newProb = {...eur.byFluid[fluid][prob]};
                  const date = new Date(new Date(newProb.date)?.setMonth(new Date(newProb.date)?.getMonth() + fullMonthsDelta)); // shift the Eur date by the delta
                  newProb.date = date?.toISOString()?.split('T')?.[0];
                  newFluidEur[prob] = newProb;
                });
                eur.byFluid = {...eur.byFluid, [fluid]: newFluidEur};

                if (wellProduction.fluids.indexOf(fluid) === -1) wellProduction.fluids.push(fluid);
              });
              return {production: wellProduction, eur};
            } catch (error) {
              console.log(error);
              return {};
            };
          default:
            return {};
        };
      } catch (error) {
        console.log(error);
        return {};
      };
    };
  };

  function handleRefreshTypeCurves(e) {
    e.stopPropagation();
    setIsLoadingTypeCurves(true);
    dispatch(getTypeCurves({email: user?.value?.email})).then(() => setIsLoadingTypeCurves(false));
  };

  function handleRefreshGroupWells(e) {
    e.stopPropagation();
    setIsLoadingGroupWells(true);
    dispatch(getGroupWells(user?.value?.email)).then(() => setIsLoadingGroupWells(false));
  };
};